var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.parsedMinutes != 0)?_c('span',[_vm._v(" "+_vm._s(_vm.parsedMinutes)+" minute"+_vm._s(_vm.minutesSuffix)+" ")]):_vm._e(),(_vm.parsedSeconds != 0)?_c('span',[_vm._v(" "+_vm._s(_vm.parsedSeconds)+" second"+_vm._s(_vm.secondsSuffix)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }